/**
 * Returns an object with values equal to the keys provided
 * @param  {string[]} keys - the object's keys and values
 * @returns {object}
 */
export const keyValueMirror = (...keys) => {
  return keys.reduce((obj, key) => ({
    ...obj,
    [key]: key,
  }), {});
};